import { useState } from 'react';

import { data } from './data/data_03_tupen_vaihto'
import kuva from './images/tuppi.png'

const TupenVaihto = ({ visibilityHandler }) => {



    // NB lisää kuvana vaikka gif, jossa tuppi vaihtuu


    const jatka = () => {

        visibilityHandler("tuppi vaihdettu")

    }



    return (


        <div className='sceneContainer'>

            <div id='image'>
                <img className='sameSizeImg' src={kuva} alt='kuva' />
            </div>

            <div id='teksti'>
                <h5>{(data.kysymysteksti != null && data.kysymysteksti != "") ? data.kysymysteksti : null}</h5>
            </div>

            <div id='actions'>
                <button onClick={() => jatka()}>jatka</button>
            </div>
        </div>

    )

}

export default TupenVaihto